import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IPhoneCallTag } from 'voxloud-types/dist/models';
import { CompanyCallHistoryService } from '../../services/company-call-history/company-call-history.service';

@Component({
  selector: 'company-call-history-tags-managment',
  templateUrl: './company-call-history-tags-managment.component.html',
  styleUrls: ['./company-call-history-tags-managment.component.scss']
})
export class CompanyCallHistoryTagsManagmentComponent {
  @Input() set tags(ts: IPhoneCallTag[]) {
    this._tags = ts || [];
    if(this._tags.length > 0) {
      if(this.selectedTag) {
        this.selectedTag = this._tags.find(t => t.id === this.selectedTag.id) || this._tags[0];
      } else {
        this.selectedTag = this._tags[0];
      }
    } else {
      this.selectedTag = null;
    }
  }
  @Output() refreshTags: EventEmitter<void> = new EventEmitter();
  public selectedTag: IPhoneCallTag = null;
  public _tags: IPhoneCallTag[] = [];
  public isEditing: boolean = false;
  public isAdding: boolean = false;

  public editedTag: IPhoneCallTag;
  public isSaving: boolean = false;
  public isError: boolean = false;

  constructor(
    private companyCallHistoryService: CompanyCallHistoryService
  ) {

  }

  public onSelectTag(tag: IPhoneCallTag) {
    this.selectedTag = tag;
  }

  public onEnablingEditing() {
    this.isEditing = true;
    this.isAdding = false;
    this.editedTag = {...this.selectedTag};
  }

  public onEnablingAdding() {
    this.isEditing = false;
    this.isAdding = true;
    this.editedTag = {
      companyId: null,
      id: null,
      value: ''
    }
  }

  public onSave() {
    if(!this.editedTag.value) return;
    this.isSaving = true;
    this.companyCallHistoryService.updateTag(this.editedTag).subscribe({
      next: (res: IPhoneCallTag) => {
        this.isError = false;
        this.isAdding = false;
        this.isEditing = false;
        this.isSaving = false;
        this.refreshTags.emit();
      },
      error: () => {
        this.isError = true;
        this.isSaving = false;
      }
    });
  }

  public onCancel() {
    this.isEditing = false;
    this.isAdding = false;
    this.isError = false;
  }

}
